import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel } from '@libs/shared/models';
import { ProductLinkDirective } from '@libs/shared/ui';
import { ProductImageModel, ProductModel } from '@libs/shop/models';
import { ProductBundleLabelComponent, ProductBundleValidToLabelComponent } from '../../catalog/product-labels/';

@Component({
  selector: 'ui-configurable-bundle-catalog-card',
  imports: [
    ProductLinkDirective,
    IconComponent,
    ProductBundleValidToLabelComponent,
    ProductBundleLabelComponent,
    MatButton,
  ],
  templateUrl: './configurable-bundle-catalog-card.component.html',
  styleUrl: './configurable-bundle-catalog-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleCatalogCardComponent {
  public product: InputSignal<ProductModel> = input.required();
  public position: InputSignal<number> = input(0);
  public showBundleLabel: InputSignal<boolean> = input(true);

  public standardImage: Signal<ProductImageModel | undefined> = computed(() =>
    this.product().images.find(image => image.imageSetName === 'Standard'),
  );

  public link: Signal<NavItemModel> = computed(() => ({
    url: '/configurable-bundles/' + this.product().bundle?.templateId,
  }));
}
